module.exports = __webpack_public_path__ + "img/startup.cdd5cfc.svg";